const dateFormatter = new Intl.DateTimeFormat('es-CR', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
});

const dateTimeFormatter = new Intl.DateTimeFormat('es-CR', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatDate(date: string | Date | null | undefined): string {
  if (!date) return '—';
  return dateFormatter.format(new Date(date));
}

// Fecha PURA (un día calendario guardado a medianoche UTC, p. ej. la fecha límite de
// una lectura): se formatea en UTC para no correrla un día hacia atrás en Costa Rica.
const dateOnlyFormatter = new Intl.DateTimeFormat('es-CR', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  timeZone: 'UTC',
});

export function formatDateOnly(date: string | Date | null | undefined): string {
  if (!date) return '—';
  return dateOnlyFormatter.format(new Date(date));
}

export function formatDateTime(date: string | Date | null | undefined): string {
  if (!date) return '—';
  return dateTimeFormatter.format(new Date(date));
}

export function formatPercent(value: number | null | undefined): string {
  if (value == null) return '—';
  return `${Math.round(value)}%`;
}

// Multiempresa #15: a colaborador can belong to several companies. For
// single-value displays (e.g. the dashboard) we show the primary membership.
// The API returns user_companies ordered is_primary-first, but we re-resolve
// here so the helper is independent of ordering. Returns null when there are
// no active memberships.
export function primaryCompanyName(
  memberships: ReadonlyArray<{ is_primary: boolean; company: { name: string } }> | null | undefined,
): string | null {
  if (!memberships?.length) return null;
  const primary = memberships.find((m) => m.is_primary) ?? memberships[0];
  return primary?.company.name ?? null;
}
